/* action type */
export const DELETE_DATA_OBJECT = 'DELETE_DATA_OBJECT';

/* action creator */
export const deleteDataObjectAction = (actionPayload: any) => {
  return {
    type: DELETE_DATA_OBJECT,
    payload: actionPayload
  };
};
